import { Center, Heading, Spinner } from '@chakra-ui/react';

type LoadingSpinnerProps = {
  text?: string;
};
export const LoadingSpinner = (props: LoadingSpinnerProps) => {
  return (
    <Center w={'100%'} h={'75%'} paddingTop={'24px'} paddingBottom={'24px'}>
      <Spinner display={'block'} borderWidth='4px' animationDuration='0.65s' color='primary.500' size='xl' />
      <br />
      <Heading display={'block'} size='md'>
        &nbsp; {props.text ?? 'Loading...'}
      </Heading>
    </Center>
  );
};
